import { useEffect, useState } from "react";

const placeholders: Record<string, { label: string, button: string }> = {
    nl: {
        label: "Omdat je de activatie van marketing cookies hebt geweigerd, kan je deze media-inhoud niet zien. Als je toch toegang wil tot de media-inhoud hoef je alleen deze cookies terug aan te zetten in",
        button: "je cookie voorkeursinstellingen",
    },
    en: {
        label: "Since you have refused the activation of marketing cookies, you cannot view this media content. If you still want access to the media content, simply enable these cookies again in your",
        button: "cookie preference settings",
    },
    fr: {
        label: "Comme vous avez refusé l’activation des cookies marketing, vous ne pouvez pas voir ce contenu multimédia. Si vous souhaitez tout de même accéder au contenu multimédia, il vous suffit d’activer à nouveau ces cookies dans",
        button: "vos paramètres de préférences de cookies",
    },
};

const CookiePlaceholder = () => {
    const [lang, setLang] = useState("nl");

    useEffect(() => {
        setLang(document?.querySelector("html")?.getAttribute("lang") || "nl");
    }, []);

    return (
        <div
            className="cta theme-default cookieconsent-message"
            style={{ padding: "20px" }}
        >
            <p>
                {placeholders[lang].label}{" "}
                <button
                    style={{ color: "#2f2e9a", fontWeight: "bold" }}
                    onClick={() => window?.Cookiebot?.renew()}
                >
                    {placeholders[lang].button}
                </button>.
            </p>
        </div>
    );
};

export default CookiePlaceholder;
